import { IconSet } from '@postscript/components';
import { NavMenuItem } from 'components/navigation/NavMenu';
import { useMemo } from 'react';

export const useSalesMenu = (): NavMenuItem[] => {
  return useMemo(
    () => [
      {
        id: 'inbox',
        label: 'My Prospects',
        icon: IconSet.Message,
        isLoading: false,
        ariaLabelledBy: 'nav-sales-conversations-title',
        link: '/workspace/my-prospects',
      },
      {
        id: 'conversation-intelligence',
        label: 'Conversation Intelligence',
        icon: IconSet.TwoWayConvo,
        isLoading: false,
        ariaLabelledBy: 'nav-sales-conversation-intelligence',
        link: '/workspace/conversation-intelligence',
      },
      {
        id: 'marketing',
        label: 'Marketing',
        icon: IconSet.DoorExit,
        isLoading: false,
        ariaLabelledBy: 'nav-sales-marketing-title',
        link: '/',
      },
    ],
    [],
  );
};
